import { publicClient } from "@toorak/tc-common-fe-sdk";
import { ExtractionProcessState } from "../../budget-review/BudgetReview.constant";
import { sortArrayByUpdatedOn } from "../../budget-review/BudgetReview.utils";
import { budgetReviewStatusEnum } from "../../ilp/list-view/BudgetTaskManagement";
// import { getTaskDetails } from "../../network/apiService";
import { getCookie } from "../../utils/cookies";
import { convertUSDToNumber, sanitizeCurrency } from "../../utils/formatChecks";
import { getChatMeta, getChatsList } from "../commentsSection/comment.action";
import { createCommentThread1 } from "../Discussions/Discussions.action";
import {
  hideLoader,
  showLoader
} from "../loaderAndException/loaderAndException.action";
import { apiUrlHost } from "../servicerOnboarding/servicerOnboarding.action";
import { getTasks, taskNames } from "../tasks/Tasks.action";
import { updateTasks } from "../tasks/Tasks.reducer";
import { RootState } from "../rootReducer";
import { getPartyId } from "../WaiverRequest/WaiverRequest.action";
import {
  budgetResponse,
  budgetReviewHeaderInterface,
  BudgetTotalInfo,
  BulkBudgetSumInterface,
  LineItem
} from "./budgetReview.interface";
import {
  isUnitShown,
  setBudgetGetResponse,
  // setStandardizedItems,
  updateBudgetApprovalHistory,
  updateBudgetHistory,
  updateBudgetStatus,
  updateBulkBudgetSum,
  updateBulkDocsData,
  updateLineItemList,
  updateBudgetPropData,
  updateSelectedPropDetails,
  updateTotalBudget,
  updateTotalFinancedBudget,
  setRedoValidationItems,
  updateBudgetChatsData
} from "./budgetReview.reducer";
import { isPLDFlow } from "../../budget-review/InternalBudgetReviewWrapper";
import { isZeroLike, uuidV4 } from "../../utils/utils";
// export function getStandardizedItems(): any {
//   return async (dispatch: any) => {
//     try {
//       dispatch(showLoader());
//       const url = `${apiUrlHost}/drawservice/assetmanagement/standardized-items`;
//       const response = await publicClient.get(url);
//       dispatch(
//         setStandardizedItems(response.data.length > 0 ? response.data : [])
//       );
//       dispatch(hideLoader());
//     } catch (err) {
//       dispatch(hideLoader());
//       console.error(err);
//     }
//   };
// }

export const finalStatus = [
  budgetReviewStatusEnum.Rejected,
  budgetReviewStatusEnum.Approved
];
export function calculateBulkBudgetSum(data: any[]) {
  const result = data.reduce(
    (acc, item) => {
      // Calculate the sum of "totalRehabBudget"
      acc.grandRehabBudget +=
        item.staticData?.documentData &&
        item.staticData?.documentData.propertyId
          ? item.extractedInfoProcessed.totalRehabBudget || 0
          : 0;

      // Check if all "areFieldsValid" values are true
      if (!item.staticData?.documentData.propertyId) {
        acc.grandFieldValidation = false;
      } else if (
        (!item.extractedInfoProcessed.areFieldsValid ||
          item.processState === ExtractionProcessState.inProgress) &&
        item.staticData?.documentData?.propertyId
      ) {
        acc.grandFieldValidation = false;
      }

      return acc;
    },
    { grandFieldValidation: true, grandRehabBudget: 0 }
  );

  return result;
}

export function getNewLineItem(item?: LineItem) {
  return {
    id: item?.id ? item.id : `tempId_${Math.random()}`,
    unit: item?.unit ?? 1,
    item: item?.item ?? "",
    description: item?.description ?? "",
    financedBudget: item?.financedBudget
      ? sanitizeCurrency(`${item.financedBudget}`)
      : "$0.00",
    budget: item ? sanitizeCurrency(`${item.budget}`) : `$0.00`,
    isMoreActionsVisible: false,
    isDescEditMode: false,
    standardizedItem: "",
    standardizedItemId: item ? item.standardizedItemId : null,
    commentId: item?.commentId
  };
}

export function getNewLineItemV2(item?: any) {
  return {
    budgetLineItemId: item?.budgetLineItemId
      ? item.budgetLineItemId
      : `tempId_${Math.random()}`,
    budgetLineItemOrder: item?.budgetLineItemOrder,
    unit: item?.unit ?? 1,
    item: item?.item ?? "",
    description: item?.description ?? "",
    financedBudget: item?.financedBudget
      ? sanitizeCurrency(`${item.financedBudget}`)
      : "$0.00",
    budget: item ? sanitizeCurrency(`${item.budget}`) : `$0.00`,
    isMoreActionsVisible: false,
    isDescEditMode: false,
    budgetDocumentId: item?.budgetDocumentId,
    isPrevDrawDisbursed: item?.isPrevDrawDisbursed,
    minBudgetAllowed: item?.minBudgetAllowed,
    commentThreadId: item?.commentThreadId
  };
}

// export function updateLineItem(lineObject: any): any {
//   return async (dispatch: any) => {
//     dispatch({
//       type: SET_LINE_ITEMS_LIST,
//       payload: lineObject
//     });
//   };
// }

export function updateLineReduxData(
  response: budgetResponse,
  dispatch: any,
  financedBudgetPercentage: number, // budgetButtonInfo
  commentsList?: any[],
  canUpdateUnit?: boolean
) {
  const lineObject: LineItem[] = [];
  let totalBudget = 0;
  let totalfinancedBudget = 0;
  let commentId: any = null;
  let isMultipleUnit = false;
  if (
    response.extractedInfoProcessed &&
    response.extractedInfoProcessed?.lineItems?.length
  ) {
    response.extractedInfoProcessed?.lineItems.forEach((item: any) => {
      const newFnancedBudget = item.budget
        ? (financedBudgetPercentage * item.budget) / 100
        : 0;
      totalBudget += item.budget;
      totalfinancedBudget += newFnancedBudget || 0;
      commentId = item.commentId
        ? item.commentId
        : commentsList
        ? commentsList?.find((comment: any) => comment.title === item.id)?.id
        : "";

      const newItem: LineItem = {
        ...item,
        ...{ commentId: commentId || "" },
        ...{ financedBudget: newFnancedBudget }
      };
      if (item.unit != null && item.unit?.toString() !== "1") {
        isMultipleUnit = true;
      }
      lineObject.push(getNewLineItem(newItem));
    });
    if (canUpdateUnit) {
      dispatch(isUnitShown(isMultipleUnit));
    }
    dispatch(updateLineItemList(lineObject));
    dispatch(updateTotalBudget(totalBudget));
    dispatch(updateTotalFinancedBudget(totalfinancedBudget));
  } else {
    dispatch(updateTotalBudget(0));
    dispatch(updateTotalFinancedBudget(0));
  }
}

const fetchDataFromAPI = async (chatId: string) => {
  try {
    const data = await getChatsList(chatId);
    return Promise.resolve({ [chatId]: data });
  } catch (error) {
    console.error("Failed to fetch data:", error);

    return {
      [chatId]: {
        customers: [],
        chatLines: []
      }
    };
  }
};

const getCustomerNamesFromChatLines = (data: any, chatData: any) => {
  const partyIdCache: {
    [partyId: string]: {
      firstName: string;
      lastName: string;
      chatId: string;
      createdAt: string;
    };
  } = {};
  let chatId = "";
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      chatId = key;
    }
  }
  return data[chatId].chatLines.map((chatLine: any) => {
    const { partyId, lineText, chatId: lineChatId, updatedOn } = chatLine;

    if (partyIdCache[partyId]) {
      return chatData[lineChatId].push({
        ...partyIdCache[partyId],
        message: lineText,
        chatId: lineChatId,
        createdAt: updatedOn
      });
    }

    const customer = data[chatId].customers.find(
      (cust: any) => cust.partyId === partyId
    );

    if (customer) {
      partyIdCache[partyId] = {
        firstName: customer.firstName,
        lastName: customer.lastName,
        chatId: lineChatId,
        createdAt: updatedOn
      };

      return chatData[lineChatId].push({
        firstName: customer.firstName,
        lastName: customer.lastName,
        message: lineText,
        chatId: lineChatId,
        createdAt: updatedOn
      });
    }
    return chatData[lineChatId].push({
      firstName: "Unknown",
      lastName: "Unknown",
      message: lineText,
      chatId: lineChatId,
      createdAt: updatedOn
    });
  });
};

async function getChatsDetails(lineObject: any[]) {
  const chatIds: string[] = [];
  const chatData: any = {};
  lineObject.forEach((item: any) => {
    if (item.commentThreadId) {
      chatIds.push(item.commentThreadId);
    }
  });
  const apiCalls = chatIds.map((chatId: string) => {
    chatData[chatId] = [];
    return fetchDataFromAPI(chatId);
  });

  // Step 2: Await all API results
  const allData = await Promise.all(apiCalls);

  allData?.map((chatId: any) =>
    getCustomerNamesFromChatLines(chatId, chatData)
  );
  return chatData;
}

export async function mergeChatDetails(
  lineObject: any[],
  budgetChatsData: any,
  dispatch: any
) {
  const commentsDetails = await getChatsDetails(lineObject);
  const newBudgetChatsData = { ...budgetChatsData, ...commentsDetails };
  dispatch(updateBudgetChatsData(newBudgetChatsData));
  const updatedWithComments = lineObject.map((item: any) => {
    if (item.commentThreadId && commentsDetails[item.commentThreadId]) {
      return {
        ...item,
        comments: commentsDetails[item.commentThreadId]
      };
    }
    return item;
  });
  return updatedWithComments;
}

async function updateLineWithComment(
  lineItems: any[],
  dispatch: any,
  financedBudgetPercentage: number, // budgetButtonInfo
  commentsList: any[],
  budgetChatsData: any,
  redoItems: any[],
  budgetReviewHeader: any,
  newReviewResponse: any,
  cb?: any
) {
  const lineObject: any[] = [];
  let totalBudget = 0;
  let totalfinancedBudget = 0;
  let commentId: any = null;
  let isMultipleUnit = false;
  const isPLDPage = isPLDFlow();
  if (lineItems?.length) {
    const ifRedoDone =
      finalStatus.includes(newReviewResponse.budgetApprovalStatus) ||
      finalStatus.includes(budgetReviewHeader.budgetReviewStatus);
    lineItems.forEach((item: any) => {
      let newFnancedBudget;
      if (ifRedoDone) {
        newFnancedBudget =
          convertUSDToNumber(item.financedBudget) === 0
            ? isPLDPage
              ? item.budget
              : (item.budget * financedBudgetPercentage) / 100
            : item.financedBudget;
        // assuming item.financedBudget === "0" is happening only for 100% disbursed items
      } else {
        const prevDrawData = redoItems.filter(
          (temp: any) => temp.item.trim() === item.item.trim()
        )[0];
        if (prevDrawData) {
          if (Number(prevDrawData.latestCompletion) === 100) {
            // If previous data exists and completion is 100%, keep the financed budget as is
            newFnancedBudget = prevDrawData.financedBudget;
          } else newFnancedBudget = item.financedBudget;
          /**
           * DONT CALCULATE FinancedBudget HERE
           */

          // else if (
          //     Number(item.budget) < Number(prevDrawData.financedBudget)
          //   ) {
          //     // If the item's budget is less than the financed budget, calculate a percentage of the new budget
          //     newFnancedBudget = (financedBudgetPercentage * item.budget) / 100;
          //   } else {
          //     // Otherwise, use the financed budget
          //     newFnancedBudget =
          //       item.financedBudget ?? prevDrawData.financedBudget;
          //     console.log(item.financedBudget, prevDrawData.financedBudget);
          //   }
        } else {
          // If no previous data exists, calculate a percentage of the new budget
          const budget =
            typeof item.budget === "string"
              ? convertUSDToNumber(item.budget)
              : item.budget;
          newFnancedBudget = budget
            ? (financedBudgetPercentage * budget) / 100
            : item.financedBudget;
        }
      }

      const commentsData = commentsList?.find(
        (comment: any) => comment.title == item.budgetLineItemId
      );
      totalBudget += item.budget;
      totalfinancedBudget += newFnancedBudget || 0;
      commentId = item.commentThreadId
        ? item.commentThreadId
        : commentsList
        ? commentsData?.id
        : "";

      const newItem: any = {
        ...item,
        ...{ commentThreadId: commentId ?? "" },
        ...{ financedBudget: newFnancedBudget }
      };
      if (item.unit != null && item.unit?.toString() !== "1") {
        isMultipleUnit = true;
      }
      lineObject.push(getNewLineItemV2(newItem));
    });
    dispatch(isUnitShown(isMultipleUnit));
    const updatedWithComments = await mergeChatDetails(
      lineObject,
      budgetChatsData,
      dispatch
    );
    // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    dispatch(updateTotalBudget(totalBudget));
    dispatch(updateTotalFinancedBudget(totalfinancedBudget));
    if (cb) {
      cb(updatedWithComments, undefined, undefined, newReviewResponse);
    } else {
      dispatch(updateLineItemList(updatedWithComments));
    }
  } else {
    dispatch(updateTotalBudget(0));
    dispatch(updateTotalFinancedBudget(0));
  }
}

export function getBudgetReviewData(
  documentId: number,
  commentsList: any[],
  financedBudgetPercentage: number,
  propertyDetails: any,
  handleEmptyLineItemsCB?: any
): any {
  return async (dispatch: any) => {
    try {
      // dispatch(showLoader());
      const url = `${apiUrlHost}/ocr/extraction/document/${documentId}`;
      const response = (await publicClient.get(url)).data;
      updateLineReduxData(
        response,
        dispatch,
        financedBudgetPercentage,
        commentsList,
        true
      );
      dispatch(setBudgetGetResponse(response));

      if (
        response.extractedInfoProcessed &&
        !response.extractedInfoProcessed?.lineItems?.length
      ) {
        if (handleEmptyLineItemsCB) handleEmptyLineItemsCB(response);
      }
      const selectProp = propertyDetails.find(
        (property: any) =>
          Number(property.loanPropertyOrder) ===
          Number(response.staticData.documentData?.propertyId)
      );
      if (selectProp) {
        const { street_line, state, city, zipcode } =
          selectProp.propertyLocation.payload.address;
        const selectedAddress = `${street_line}, ${city}, ${state}, ${zipcode}`;
        dispatch(
          updateSelectedPropDetails({
            selectedPropInfo: selectedAddress,
            selectedPropId: Number(response.staticData.documentData?.propertyId)
          })
        );
      } else {
        dispatch(
          updateSelectedPropDetails({
            selectedPropInfo: null,
            selectedPropId: null
          })
        );
      }
      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
      console.error(err);
    }
  };
}
export async function deleteLineItems(payload: any, loanId: string) {
  const url = `${apiUrlHost}/ocr/budget-line/delete/line-items/${loanId}`;
  try {
    const resp = await publicClient.delete(url, { data: payload });
    return Promise.resolve(resp);
  } catch (e) {
    console.error(e);
    return Promise.reject(e);
  }
}

export function getBudgetReviewDataV2(
  commentsList: any[],
  lineItems: any[],
  financedBudgetPercentage: number,
  propertyDetails: any,
  budgetExtractionGetResponse: any,
  budgetChatsData: any,
  redoItems: any[],
  budgetReviewHeader: any,
  newReviewResponse: any,
  cb: any
): any {
  return (dispatch: any) => {
    try {
      updateLineWithComment(
        lineItems,
        dispatch,
        financedBudgetPercentage,
        commentsList,
        budgetChatsData,
        redoItems,
        budgetReviewHeader,
        newReviewResponse,
        cb
      );
      // dispatch(setBudgetGetResponse(response));

      // if (
      //   lineItems?.length
      // ) {
      //   handleEmptyLineItemsCB && handleEmptyLineItemsCB(response);
      // }
      const selectProp = propertyDetails.find(
        (property: any) =>
          Number(property.loanPropertyOrder) ===
          Number(
            budgetExtractionGetResponse.staticData.documentData?.propertyId
          )
      );
      if (selectProp) {
        const { street_line, state, city, zipcode } =
          selectProp.propertyLocation.payload.address;
        const selectedAddress = `${street_line}, ${city}, ${state}, ${zipcode}`;
        dispatch(
          updateSelectedPropDetails({
            selectedPropInfo: selectedAddress,
            selectedPropId: Number(
              budgetExtractionGetResponse.staticData.documentData?.propertyId
            )
          })
        );
      } else {
        dispatch(
          updateSelectedPropDetails({
            selectedPropInfo: null,
            selectedPropId: null
          })
        );
      }
      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
      console.error(err);
    }
  };
}

export async function updatePredictionStatus(
  budgetReviewResponse: any,
  processState: ExtractionProcessState,
  lineItems: any[],
  dispatch: any,
  cb?: any
) {
  const reqBody = { ...budgetReviewResponse };
  reqBody.processState = processState;
  reqBody.status = "REVIEW_IN_PROGRESS";
  reqBody.extractedInfoProcessed = {
    lineItems
  };
  const url = `${apiUrlHost}/ocr/extraction/document/${budgetReviewResponse.externalDocumentId}`;
  const resp = (await publicClient.patch(url, reqBody)).data;
  dispatch(setBudgetGetResponse(resp.documentDto));
  if (cb) cb(resp.documentDto);
}

/**
 * Creates budget_loan_info + budget_document_info + extraction_source_document
 * via POST /ocr/budget-loan/create/{source} when OCR never produced them.
 */
export async function createBudgetLoan(
  source: string,
  requestBody: any
): Promise<any> {
  const url = `${apiUrlHost}/ocr/budget-loan/create/${source}`;
  return (await publicClient.post(url, requestBody)).data;
}

/**
 * Bootstrap missing OCR budget backbone from a tagged document, mark as
 * PREDICTION_SKIPPED_MANUAL_ENTRY, then reload budget-loan into redux.
 */
export async function bootstrapBudgetManualEntry({
  loanId,
  createPayload,
  lineItems,
  dispatch,
  onBudgetLoaded
}: {
  loanId: string;
  createPayload: any;
  lineItems: any[];
  dispatch: any;
  onBudgetLoaded?: (docId: number, budgetLines: any, response: any) => void;
}): Promise<any> {
  const externalDocumentId =
    createPayload?.budgetDocumentInfo?.[0]?.externalDocumentId;
  if (!externalDocumentId) {
    throw new Error("externalDocumentId is required to bootstrap budget manual entry");
  }

  await createBudgetLoan("TC", createPayload);

  const extractionStub = {
    externalDocumentId: String(externalDocumentId),
    toorakLoanId: loanId,
    tagCode: "SCOW",
    processState: ExtractionProcessState.predictionSkippedManualEntry,
    status: "REVIEW_IN_PROGRESS"
  };

  await updatePredictionStatus(
    extractionStub,
    ExtractionProcessState.predictionSkippedManualEntry,
    lineItems || [],
    dispatch
  );

  return dispatch(
    getBudgetData(loanId, Number(externalDocumentId), (docId: number, budgetLines: any, response: any) => {
      if (onBudgetLoaded) {
        onBudgetLoaded(docId, budgetLines, response);
      }
    })
  );
}

export function updateConsolidatedUnit(
  budgetReviewResponse: any,
  isUnit: boolean,
  cb?: any
): any {
  return async (dispatch: any) => {
    // const reqBody = { ...budgetReviewResponse };
    try {
      dispatch(showLoader());
      const reqBody = { ...budgetReviewResponse };
      const extractedInfoProcessed = {
        ...budgetReviewResponse.extractedInfoProcessed
      };
      extractedInfoProcessed.isUnit = isUnit;
      reqBody.extractedInfoProcessed = extractedInfoProcessed;

      const url = `${apiUrlHost}/ocr/extraction/document/${budgetReviewResponse.externalDocumentId}`;
      const resp = (await publicClient.patch(url, reqBody)).data;

      dispatch(isUnitShown(isUnit));

      dispatch(setBudgetGetResponse(resp.documentDto));
      dispatch(hideLoader());
      if (cb) cb(resp);
    } catch (e) {
      dispatch(hideLoader());
      console.error(e);
    }
  };
}

export async function updateSelectionMode(docId: string, payload: any) {
  try {
    const url = `${apiUrlHost}/ocr/budget-document/${docId}`;
    await publicClient.patch(url, payload);
  } catch (e) {
    console.error(e);
    return Promise.reject();
  }
  return undefined;
}

export function lineItemResponse(lineItems: any[]) {
  const lineItemsReq: any[] = [];
  let areFieldsValid = true;
  lineItems
    // .filter(item => item.budget || item.item || item.standardizedItemId) //don't pass empty row
    .forEach((item: any, index: number) => {
      if (item.item.trim() === "") {
        areFieldsValid = false;
      }

      const lineItem = {
        budgetLineItemOrder: index,
        budgetLineItemId: item.budgetLineItemId,
        unit: item.unit,
        commentThreadId: item.commentThreadId,
        comments: item.comments,
        item: item.item,
        description: item.description,
        financedBudget:
          typeof item.financedBudget === "number"
            ? item.financedBudget
            : convertUSDToNumber(item.financedBudget),
        budget:
          typeof item.budget === "number"
            ? item.budget
            : convertUSDToNumber(item.budget),
        status: item.status
      };
      if (
        typeof item.budgetLineItemId === "string" &&
        item.budgetLineItemId.startsWith("tempId_")
      ) {
        delete lineItem.budgetLineItemId;
      }

      lineItemsReq.push(lineItem);
    });
  return { lineItemsReq, areFieldsValid };
}

function updateReduxFromResponse(
  response: any,
  selectedDocId: any,
  dispatch: any
) {
  if (!response) {
    dispatch(updateBudgetPropData([]));
    return undefined;
  }
  dispatch(
    updateBulkBudgetSum({
      grandFieldValidation: response.validationFlag,
      grandRehabBudget: response.grandCalculatedTotalBudget
    })
  );
  const budgetLines = response.budgetDocumentInfoList?.find(
    (budget: any) => budget.externalDocumentId == selectedDocId
  );
  dispatch(updateBudgetPropData(response.budgetDocumentInfoList || []));
  return budgetLines;
}

export function updateBudgetLineItems(
  lineItems: LineItem[],
  docId: string,
  updateRedux?: boolean,
  cb?: any
): any {
  return async (dispatch: any) => {
    try {
      // not make update call for empty line items array
      if (Array.isArray(lineItems) && !lineItems.length) return;
      const { lineItemsReq } = lineItemResponse(lineItems);
      // let areFieldsValid: boolean = true;
      // budgetReviewResponse.processState === ExtractionProcessState.inProgress
      //   ? false
      //   : true;
      // lineItems
      //   // .filter(item => item.budget || item.item || item.standardizedItemId) //don't pass empty row
      //   .forEach((item: any, index: number) => {
      //     if (item.item.trim() === "") {
      //       areFieldsValid = false;
      //     }
      //     const lineItem = {
      //       budgetLineItemOrder: index,
      //       budgetLineItemId: item.budgetLineItemId,
      //       unit: item.unit,
      //       commentThreadId: item.commentThreadId,
      //       comments: item.comments,
      //       item: item.item,
      //       description: item.description,
      //       financedBudget: convertUSDToNumber(item.financedBudget),
      //       budget: convertUSDToNumber(item.budget),
      //       status: item.status
      //     };
      //     if (
      //       typeof item.budgetLineItemId === "string" &&
      //       item.budgetLineItemId.startsWith("tempId_")
      //     ) {
      //       delete lineItem.budgetLineItemId;
      //     }

      //     lineItemsReq.push(lineItem);
      //   });
      const url = `${apiUrlHost}/ocr/budget-line/${docId}`;
      const response = (await publicClient.patch(url, lineItemsReq)).data;
      // let BulkBudgetSum: BulkBudgetSumInterface = {
      //   grandFieldValidation: response.grandFieldValidation,
      //   grandRehabBudget: response.grandTotalRehabBudget
      // };
      // dispatch(updateBulkBudgetSum(BulkBudgetSum));
      if (updateRedux) updateReduxFromResponse(response, docId, dispatch);
      if (cb) cb(response);
    } catch (e) {
      console.error(e);
    }
  };
}

export function updateBudgetReview(
  lineItems: LineItem[],
  budgetReviewResponse: any,
  budgetButtonInfo: BudgetTotalInfo,
  status: string,
  budgetReviewHeader: budgetReviewHeaderInterface,
  financedBudgetPercentage?: number,
  cb?: any
): any {
  return async (dispatch: any) => {
    try {
      if (!budgetReviewHeader.selectedPropId) {
        console.error("can't update without PropertyId");
        return undefined;
      }
      const lineItemsReq: any[] = [];
      let areFieldsValid: boolean =
        budgetReviewResponse.processState !== ExtractionProcessState.inProgress;
      lineItems
        // .filter(item => item.budget || item.item || item.standardizedItemId) //don't pass empty row
        .forEach((item: any) => {
          if (item.item.trim() === "") {
            areFieldsValid = false;
          }

          const lineItem = {
            id: item.id,
            unit: item.unit,
            commentId: item.commentId,
            item: item.item,
            description: item.description,
            financedBudget: convertUSDToNumber(item.financedBudget),
            budget: convertUSDToNumber(item.budget),
            standardizedItemId: item.standardizedItemId,
            status: item.status
          };

          if (item.id.startsWith("tempId_")) {
            delete lineItem.id;
          }

          lineItemsReq.push(lineItem);
        });
      const reqBody = { ...budgetReviewResponse };
      const extractedInfoProcessed = {
        lineItems: lineItemsReq,
        areFieldsValid,
        propertyInfo: budgetReviewHeader.selectedPropInfo,
        toorakLoanId: budgetReviewResponse.toorakLoanId,
        externalDocumentId: budgetReviewResponse.externalDocumentId,
        approvedBy: budgetReviewResponse.approvedBy,
        isUnit: budgetReviewResponse.extractedInfoProcessed?.isUnit,
        totalRehabBudget: convertUSDToNumber(budgetButtonInfo.rehabBudget),
        reviewedBy: budgetReviewResponse.reviewedBy,
        primaryLoanId: budgetReviewHeader.primaryLoanId,
        financedBudget: convertUSDToNumber(
          budgetButtonInfo.financedBudgetAmount
        ),
        propertyId: budgetReviewHeader.selectedPropId
      };
      reqBody.status = status;
      reqBody.extractedInfoProcessed = extractedInfoProcessed;

      const url = `${apiUrlHost}/ocr/extraction/document/${budgetReviewResponse.externalDocumentId}`;
      const response = (await publicClient.patch(url, reqBody)).data;
      if (financedBudgetPercentage) {
        updateLineReduxData(
          response.documentDto,
          dispatch,
          financedBudgetPercentage
        );
      }
      const BulkBudgetSum: BulkBudgetSumInterface = {
        grandFieldValidation: response.grandFieldValidation,
        grandRehabBudget: response.grandTotalRehabBudget
      };
      dispatch(updateBulkBudgetSum(BulkBudgetSum));
      if (cb) cb(response.documentDto);
      return undefined;
    } catch (err) {
      console.error(err);
      return undefined;
    }
  };
}

export const postLineComment = async (chatId: any, payload: any) => {
  try {
    const url = `${apiUrlHost}/chatservice/${chatId}/lines`;
    await publicClient.post(url, payload);
    return Promise.resolve(chatId);
  } catch (e) {
    console.error(e);
    return Promise.reject(chatId);
  }
};

export const getCommentsList = async (docsId: string) => {
  const comments: any = (
    await getChatMeta("DOCS", docsId, "CHAT_TOPIC", "BUDGET_REVIEW")
  ).data;
  return comments;
};

export const createAndUpdateComments = async (
  commentId: string,
  docId: string,
  commentText: string,
  title: string
) => {
  const { partyId } = getPartyId();
  const payload = {
    partyId,
    lineText: commentText,
    hasDocuments: false
  };
  let commentThreadId;
  try {
    if (commentId) {
      commentThreadId = commentId;
    } else {
      const res: any = await createCommentThread1(
        "DOCS",
        docId,
        "CHAT_TOPIC",
        "BUDGET_REVIEW",
        title
      );
      commentThreadId = res.id;
    }
    return await postLineComment(commentThreadId, payload);
  } catch (error) {
    console.error("An error occurred:", error);
    return undefined;
  }
};

export function updateBudgetReviewBulk(reqBody: any[], cb?: any): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const url = `${apiUrlHost}/ocr/extraction/document/bulkUpdate`;
      const response = (await publicClient.patch(url, reqBody)).data;
      const currDoc: any = {};

      const BulkBudgetSum: BulkBudgetSumInterface = {
        grandFieldValidation:
          response[response.length - 1].grandFieldValidation, // the last object is supposed to have the latest value
        grandRehabBudget: response[response.length - 1].grandTotalRehabBudget
      };
      dispatch(updateBulkBudgetSum(BulkBudgetSum));
      // dispatch({
      //   type: UPDATE_BULK_DOCS_DATA,
      //   payload: newBulkData
      // });
      if (cb) cb(currDoc.documentDto);
      dispatch(hideLoader());
    } catch (e) {
      console.error("An error occurred:", e);
      dispatch(hideLoader());
    }
  };
}

async function selfAssigneTask(sortedBudgetHistory: any[], response: any) {
  const { partyId } = getPartyId();

  const newBudget: any[] = [
    {
      op: "replace",
      assignedBy: partyId,
      assigneePartyId: partyId,
      taskName: sortedBudgetHistory[0].taskName,
      taskStatus: sortedBudgetHistory[0].taskStatus,
      taskId: sortedBudgetHistory[0].taskId,
      comment: "Assigned to self"
    }
  ];

  const selfAssigneeReqtBody = [
    {
      resourceId: response.resourceId,
      resourceType: response.resourceType,
      assignedTasks: newBudget
    }
  ];
  const url = `${apiUrlHost}/taskservice/tasks`;
  try {
    await publicClient.patch(url, selfAssigneeReqtBody);
    return Promise.resolve(newBudget[0]);
  } catch (e) {
    console.error(e);
    return undefined;
  }
}

// export const getBudgetApprove = async (dispatch: any, payload: any) => {
//   getTaskDetails(payload).then((response: any) => {
//     const budgetApproveTask = response?.data[0].assignedTasks.filter(
//       (task: { taskName: string }) => task.taskName === "budgetApprove"
//     );
//     dispatch(updateBudgetApprovalHistory(budgetApproveTask));
//   });
// };

export const getBudgetHistory =
  (reqBody: any, loanId: string): any =>
  async (dispatch: any) => {
    try {
      const url = `${apiUrlHost}/taskservice/tasks/audit/fetch`;
      const response = (await publicClient.post(url, reqBody)).data;

      const sortedBudgetHistory = sortArrayByUpdatedOn(
        response[0]?.budgetReview
      );
      if (response[0] && response[0].budgetApprove) {
        const sortedBudgetApprovalHistory = sortArrayByUpdatedOn(
          response[0].budgetApprove
        );

        dispatch(updateBudgetApprovalHistory(sortedBudgetApprovalHistory));
      } else {
        getTasks(
          dispatch,
          {
            resourceTypes: ["LOAN"],
            resourceIds: [loanId],
            taskNames: [
              taskNames.TAG,
              taskNames.SPLIT,
              taskNames.REVIEW,
              taskNames.RECONCILE,
              taskNames.BUDGET_REVIEW,
              taskNames.BUDGET_APPROVE
            ]
          },
          false,
          true
        );
      }
      dispatch(updateBudgetStatus(sortedBudgetHistory[0].taskStatus));
      if (
        [
          budgetReviewStatusEnum.ReadyForBudgetReview,
          budgetReviewStatusEnum.InProgress
        ].includes(
          sortedBudgetHistory[0].taskStatus as budgetReviewStatusEnum
        ) &&
        [
          "System",
          "UnAssigned",
          "None",
          "Merchants Team Member",
          null,
          ""
        ].includes(sortedBudgetHistory[0].assigneePartyId)
      ) {
        // assign to self
        const newTaskObj = await selfAssigneTask(
          sortedBudgetHistory,
          response[0]
        );
        sortedBudgetHistory.unshift(newTaskObj);
      }
      dispatch(updateBudgetHistory(sortedBudgetHistory));
      return response;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  };

export const createBudgetInquiry = async (
  loanId: string,
  loanStage: string,
  financedBudgetAmountCalculated: string,
  datapoint: string
) => {
  try {
    const geturl = `${apiUrlHost}/aggregate/exceptionservice/${loanId}?loanStage=${loanStage}&limit=200`;
    const data = (await publicClient.get(geturl))?.data;
    const isAlreadyThere =
      isZeroLike(financedBudgetAmountCalculated) ||
      Array.isArray(data?.exceptions?.exceptions) &&
      data.exceptions.exceptions.some(
        (ex: any) =>
          ex.status?.toLowerCase() === "open" &&
          Array.isArray(ex.tags) &&
          ex.tags.includes("Budget Document") &&
          ex.tags.includes(datapoint)
      );
    if (isAlreadyThere) {
      return undefined;
    }
    const id = uuidV4();
    const reqBody = {
      loanExceptionStatus: "",
      dueDiligenceStatus: "",
      loanId,
      loanStage,
      exceptions: [
        {
          description: "",
          status: "Open",
          type: "Inquiry",
          externalExceptionId: id,
          ddLastUpdate: "",
          name: "",
          initialComment: "",
          conclusionComment: "",
          hold: false,
          clientResponse: "",
          exceptionCategory: "",
          exceptionSubCategory: "",
          createdBy: getCookie("person_id"),
          tags: ["Budget Document"],
          response: [],
          statuses: [],
          datapoints: [datapoint],
          source: "WORKFLOW",
          // takeoutPartnerId: "f205d903-65e2-46e8-b5cd-f0cc858ca142",
          initialDescription:
            "The budget document is currently missing, and is essential for conducting a budget review. Please ensure it is provided to proceed with the review process."
        }
      ],
      grades: []
    };
    const url = `${apiUrlHost}/exceptionservice/${loanId}?loanStage=${loanStage}&visibility=internal`;
    const response = (await publicClient.post(url, reqBody))?.data;
    return response;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

export const updateStatusOnDocument = async (
  loanId: string,
  status: string,
  dispatch: any,
  tasks?: any
) => {
  try {
    dispatch(showLoader());
    const userId = getCookie("person_id") || "";
    let url = `${apiUrlHost}/ocr/extraction/${loanId}/status?tags=SCOW,REBD&status=${status}`;
    if (
      status === budgetReviewStatusEnum.InProgress ||
      status === budgetReviewStatusEnum.ReadyForBudgetApproval
    ) {
      url = `${url}&reviewedBy=${userId}`;
    } else if (status === budgetReviewStatusEnum.Approved) {
      const updatedTasks: any = JSON.parse(JSON.stringify(tasks));
      // updatedTasks[0].
      const assignedTasks = updatedTasks?.[0]?.assignedTasks.find((task: any) =>
        [taskNames.BUDGET_REVIEW].includes(task.taskName)
      );
      let reviewedBy: any;
      if (assignedTasks) {
        updatedTasks[0].assignedTasks = assignedTasks;
        if (
          [
            "System",
            "UnAssigned",
            "None",
            "Merchants Team Member",
            null,
            ""
          ].includes(updatedTasks[0].assignedTasks[0].assigneePartyId)
        ) {
          reviewedBy = getCookie("person_id");
        } else {
          reviewedBy = updatedTasks[0].assignedTasks[0].assigneePartyId;
        }
      } else {
        reviewedBy = getCookie("person_id");
      }

      url = `${url}&approvedBy=${userId}&reviewedBy=${reviewedBy}`;
    }
    const response = (await publicClient.put(url)).data;
    dispatch(hideLoader());
    return response;
  } catch (e) {
    console.error(e);
    dispatch(hideLoader());
    return undefined;
  }
};

export const updateBudgetStatusV2 = async (
  loanId: string,
  payload: any,
  dispatch: any
) => {
  try {
    dispatch(showLoader());
    const url = `${apiUrlHost}/ocr/budget-loan/${loanId}`;
    // const payload = {
    //   budgetApprovalStatus: status
    // };
    const response = (await publicClient.patch(url, payload)).data;
    dispatch(hideLoader());
    return Promise.resolve(response);
  } catch (e) {
    console.error(e);
    dispatch(hideLoader());
    return Promise.reject(e);
  }
};

export const getPreviousVersionData = async (
  extDocId: any,
  version: string,
  financedBudgetPercentage: number,
  dispatch: any
) => {
  try {
    dispatch(showLoader());
    const url = `${apiUrlHost}/ocr/budget-line/${extDocId}?version=${version}`;
    const response = (await publicClient.get(url)).data;
    dispatch(hideLoader());
    const lineObject: any[] = [];
    response.forEach((item: any) => {
      const newFnancedBudget = item.budget
        ? (financedBudgetPercentage * item.budget) / 100
        : 0;

      const newItem: any = {
        ...item,
        ...{ commentThreadId: item?.commentThreadId ?? "" },
        ...{ financedBudget: newFnancedBudget }
      };
      // if (item.unit != null && item.unit?.toString() !== "1") {
      //   isMultipleUnit = true;
      // }
      lineObject.push(getNewLineItemV2(newItem));
    });
    lineObject.sort(
      (a: any, b: any) => a.budgetLineItemOrder - b.budgetLineItemOrder
    );
    return Promise.resolve(lineObject);
  } catch (e) {
    console.error(e);
    dispatch(hideLoader());
    return Promise.reject(e);
  }
};

export const updateTotalBudgetAPI = async (
  loanId: string,
  newBudget: string
) => {
  try {
    const url = `${apiUrlHost}/ocr/budget-loan/${loanId}`;
    const payload = {
      updatedTotalRehabBudget: newBudget
    };

    const response = (await publicClient.patch(url, payload)).data;
    return Promise.resolve(response);
  } catch (e) {
    console.error(e);
    return Promise.reject(e);
  }
};
// https://qa.toorakcapital.info/internal/loan/createLoan/BridgeLoan/POST/1101520493/budgetReview
// https://uat.toorakcapital.info/internal/loan/createLoan/BridgeLoan/POST/11115136342/budgetReview
// const tempResp = [
//   {
//     item: "HVAC-A/C",
//     financedBudget: "3000",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Electrical Panel / General Wiring",
//     financedBudget: "2500",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Hot Water Heater",
//     financedBudget: "800",
//     latestCompletion: "0.0"
//   },
//   {
//     item: "Wood & Laminate Floors",
//     financedBudget: "2500",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Countertops & Backsplashes",
//     financedBudget: "5000",
//     latestCompletion: "0.0"
//   },
//   {
//     item: "Door Replacement",
//     financedBudget: "500",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Cleanout & Hauloff",
//     financedBudget: "1500",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Electrical Fixtures & Devices",
//     financedBudget: "525",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Kitchen Appliances",
//     financedBudget: "1500",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Kitchen Cabinetry",
//     financedBudget: "6000",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Roof",
//     financedBudget: "14000",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Painting Interior",
//     financedBudget: "2600",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Fencing",
//     financedBudget: "3000",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Painting Exterior",
//     financedBudget: "1800",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Interior Trim Carpentry",
//     financedBudget: "800",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Landscaping",
//     financedBudget: "800",
//     latestCompletion: "100.0"
//   },
//   {
//     item: "Plumbing Fixtures",
//     financedBudget: "200",
//     latestCompletion: "100.0"
//   }
// ];

export const getRedoValidationItems = async (
  loanId: string,
  selectedPropId: string,
  dispatch: any
) => {
  try {
    dispatch(showLoader());
    const url = `${apiUrlHost}/drawservice/assetmanagement/loan/${loanId}/inspection-items/${selectedPropId}`;

    const response = (await publicClient.get(url)).data;
    dispatch(setRedoValidationItems({ [selectedPropId]: response }));
    dispatch(hideLoader());
    return Promise.resolve(response);
  } catch (e) {
    console.error(e);
    dispatch(hideLoader());
    return Promise.reject(e);
  }
};

export const redoBudgetReview = async (
  loanId: string,
  payload: any,
  selectedPropId: string,
  dispatch: any,
  cb?: any,
  budgetDocSelected?: any
) => {
  let lineItems: any[] = [];
  try {
    dispatch(showLoader());
    const url = `${apiUrlHost}/ocr/budget-loan/${loanId}/redo`;
    const response = (await publicClient.post(url, payload)).data;
    const propertyViewData = response.filter(
      (item: any) => item.propertyId == selectedPropId
    )[0];
    dispatch(hideLoader());
    if (propertyViewData) {
      lineItems = propertyViewData.budgetLineItemList;
      lineItems.sort(
        (a: any, b: any) => a.budgetLineItemOrder - b.budgetLineItemOrder
      );
      if (cb) cb(budgetDocSelected || lineItems, propertyViewData);
    } else {
      if (cb) cb(budgetDocSelected || lineItems, propertyViewData);
    }
    return Promise.resolve(lineItems);
  } catch (e) {
    console.error(e);
    dispatch(hideLoader());
    return Promise.reject(lineItems);
  }
};

const mergePatchedTasksIntoStore = (
  assignedTasksObj: any[],
  updatedAssignedTasks: any[],
  currentAssignedTasks: any[]
) => {
  const patchedTaskIds = new Set(
    assignedTasksObj.map((task: any) => task.taskId).filter(Boolean)
  );

  const mergedFromResponse = updatedAssignedTasks
    .filter((updatedTask: any) => patchedTaskIds.has(updatedTask.taskId))
    .map((updatedTask: any) => {
      const existingTask = currentAssignedTasks.find(
        (task: any) => task.taskId === updatedTask.taskId
      );
      return existingTask ? { ...existingTask, ...updatedTask } : null;
    })
    .filter(Boolean);

  if (mergedFromResponse.length) {
    return mergedFromResponse;
  }

  // Fallback when API omits taskId: patch only the task(s) we sent.
  return assignedTasksObj
    .map((patch: any) => {
      const existingTask = currentAssignedTasks.find(
        (task: any) =>
          (patch.taskId && task.taskId === patch.taskId) ||
          (patch.taskName && task.taskName === patch.taskName)
      );
      return existingTask
        ? {
            ...existingTask,
            ...patch,
            taskStatus: patch.taskStatus ?? existingTask.taskStatus
          }
        : null;
    })
    .filter(Boolean);
};

export function updateStatusOnTask(
  loanId: string,
  assignedTasksObj: any[],
  budgetStatusHistory: any[],
  budgetApprovalHistory?: any[]
): any {
  return async (dispatch: any, getState: () => RootState) => {
    try {
      dispatch(showLoader());
      const url = `${apiUrlHost}/taskservice/tasks`;
      const reqBody = [
        {
          resourceId: loanId,
          resourceType: "LOAN",
          assignedTasks: assignedTasksObj
        }
      ];
      const response = (await publicClient.patch(url, reqBody)).data;
      const updatedAssignedTasks = response[0]?.assignedTasks ?? [];
      const currentAssignedTasks =
        getState()?.TasksStore?.tasks?.[0]?.assignedTasks ?? [];
      const tasksToMergeIntoStore = mergePatchedTasksIntoStore(
        assignedTasksObj,
        updatedAssignedTasks,
        currentAssignedTasks
      );

      if (tasksToMergeIntoStore.length) {
        dispatch(updateTasks(tasksToMergeIntoStore));
      }

      updatedAssignedTasks.forEach((resp: any) => {
        const newBudgetHistory =
          resp.taskName === "budgetReview"
            ? [...budgetStatusHistory]
            : budgetApprovalHistory
            ? [...budgetApprovalHistory]
            : [];
        resp.updatedOn = new Date();
        newBudgetHistory.unshift(resp);
        switch (resp.taskName) {
          case "budgetReview":
            dispatch(updateBudgetStatus(resp.taskStatus));
            dispatch(updateBudgetHistory(newBudgetHistory));
            break;

          case "budgetApproval":
            if (budgetApprovalHistory) {
              dispatch(updateBudgetApprovalHistory(newBudgetHistory));
            }
            break;

          default:
            break;
        }
      });
      dispatch(hideLoader());
      return response;
    } catch (e) {
      console.error(e);
      dispatch(hideLoader());
      return undefined;
    }
  };
}

export function getBulkBudgetReviewData(toorakLoanId: string, cb?: any): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const url = `${apiUrlHost}/ocr/extraction/${toorakLoanId}/documents?tags=REBD,SCOW`;
      const response: budgetResponse[] = (await publicClient.get(url)).data;
      // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>..
      dispatch(updateBulkDocsData(response));
      if (cb) cb(response);

      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
      console.error(err);
    }
  };
}

export async function reTriggerBudgetExtraction(
  toorakLoanId: string,
  cb?: any
): Promise<any> {
  try {
    const url = `${apiUrlHost}/ocr/extraction/retrigger/${toorakLoanId}/documents?tags=REBD,SCOW`;
    const response: any[] = (await publicClient.get(url)).data;
    if (cb) cb(response);
  } catch (err) {
    console.error(err);
  }
}

export function getBudgetData(
  loanId: string,
  selectedDocId: number,
  cb: any
): any {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader());
      const url = `${apiUrlHost}/ocr/budget-loan/${loanId}`;
      const response: any = (await publicClient.get(url)).data;
      dispatch(setBudgetGetResponse(response));
      const budgetLines = updateReduxFromResponse(
        response,
        selectedDocId,
        dispatch
      );
      dispatch(updateLineItemList(budgetLines?.budgetLineItemList));
      if (cb) cb(selectedDocId, budgetLines, response);

      dispatch(hideLoader());
    } catch (err) {
      dispatch(hideLoader());
      // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
      console.error(err);
    }
  };
}

export async function getUserDetails(payload: any) {
  try {
    const url = `${apiUrlHost}/customer/fetch`;
    const response: any = (await publicClient.post(url, payload)).data;
    return Promise.resolve(response);
  } catch (error) {
    console.error("Failed to fetch data:", error);
    return Promise.reject(error);
  }
}